<template>
<div>silent renew...</div>
</template>

<script>
// import { auth } from '@/services/auth.service'

export default {
  name: 'SilentRenew',

  created () {
    this.$auth.userManager.signinSilentCallback()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SilentRenew.vue